module.exports = __webpack_public_path__ + "img/T7.8236b43a.png";